export default {
  namespaced: true,
  state: {
    footer: true
  },
  getters: {
    getFooter: st => st.footer
  },
  actions: {
    SET_FOOTER({ state }, status) {
      state.footer = status;
    }
  },
  mutations: {}
};
